/* This is the Climate Change for components N.8 */
<template>
  <v-container>
    <div>
      <strong>
        <span v-html="title"></span>
      </strong>
    </div>
    <!-- The upper part table
    <div>
      <pre>
  ក.ចំនួនថ្ងៃសរុបដែលសិស្សអវត្តមានកាលពីឆ្នាំសិក្សាកន្លងទៅ (ឆ្នាំសិក្សាមុន)</pre
      >
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="800" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 200px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              ចំនួន
            </td>
            <td class="row-header" colspan="2">{{ preLevel[0] }}</td>
            <td class="row-header" colspan="2">{{ preLevel[1] }}</td>
            <td class="row-header" colspan="2">{{ preLevel[2] }}</td>
            <td class="row-header" colspan="2">{{ preLevel[3] }}</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr v-for="(value, row) in 1" :key="row">
            <td class="td-title">{{ absentLabel[row] }}</td>
            <td v-for="(value, col) in data[row].d.length" :key="col">
              <numberinput v-model="data[row].d[col]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    The second part table
    <div>
      <br />
      <pre>
  ខ​.ចំនួនថ្ងៃសរុបដែលសិស្សអវត្តមានក្នុងឆ្នាំសិក្សាកន្លងទៅដែលអវត្តមានលើសពី ២០ថ្ងៃ ​និងតិចជាង ៤០ថ្ងៃ។ (កុំរាប់សិស្សពីរដង)៖ </pre
      >
    </div>
    -->
    <div>
      <table style="height: 72px" border="1px;" width="800" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 200px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              ចំនួនសិស្សអវត្តមាន
            </td>
            <td class="row-header" colspan="2">{{ preLevel[0] }}</td>
            <td class="row-header" colspan="2">{{ preLevel[1] }}</td>
            <td class="row-header" colspan="2">{{ preLevel[2] }}</td>
            <td class="row-header" colspan="2">{{ preLevel[3] }}</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr v-for="(value, row) in 2" :key="row">
            <td class="td-title">{{ absentLabel[row] }}</td>
            <td v-for="(value, col) in data[row].d.length" :key="col">
              <numberinput v-model="data[row].d[col]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { absentLabel } from "@/utils/ascf/climateVariables.js";
import { preLevel } from "@/utils/ascf/preConfig.js";

export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      absentLabel: absentLabel,
      preLevel: preLevel,
    };
  },
};
</script>

<style scoped>
.number {
  width: 45px;
  text-align: center;
}
.td-title {
  width: 170px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
.row-data {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header {
  width: 90px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>
